import { AdminSubheader } from "features/AdminSubheader";

export function VideoUploadsSubheader() {
	return <AdminSubheader items={[
		{
			label: "Not Sent",
			link: "/video-uploads/not-sent"
		},
		{
			label: "In Queue",
			link: "/video-uploads/in-queue"
		},
		{
			label: "Processing",
			link: "/video-uploads/in-processing"
		},
		{
			label: "Completed",
			link: "/video-uploads/finished"
		},
		{
			label: "Failed",
			link: "/video-uploads/errored"
		},
		{
			label: "All Videos",
			link: "/video-uploads/all"
		},
		{
			label: "Deleted Videos",
			link: "/video-uploads/deleted"
		},
	]} />
}
